import { render, staticRenderFns } from "./ServiceAboutus.vue?vue&type=template&id=ef814844"
import script from "./ServiceAboutus.vue?vue&type=script&lang=js"
export * from "./ServiceAboutus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports